exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mapContainer[data-v-4308156f] {\r\n  width: 98%;\r\n  height: 320px;\r\n  margin: auto;\r\n  /* padding: 10px; */\r\n  /* padding-left: 3%;\r\n  padding-right: 3%; */\n}\n.map[data-v-4308156f] {\r\n  width: 100%;\r\n  height: 100%;\n}\r\n", ""]);

// exports
